import axios from 'axios';

// In production, use relative URLs (empty string) since frontend and backend are served from same origin
// In development, use VITE_API_URL or fallback to localhost:5000
const API_BASE_URL = import.meta.env.VITE_API_URL || (import.meta.env.PROD ? '' : 'http://localhost:5000');

// Configure axios to send cookies
axios.defaults.withCredentials = true;

// Track if we're already redirecting to prevent multiple redirects
let isRedirecting = false;

// Add response interceptor to handle 401 errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Get the request URL to check if it's the /auth/user endpoint
      const requestUrl = error.config?.url || '';
      const isAuthUserRequest = requestUrl.includes('/auth/user');

      // For /auth/user requests, don't redirect - just let the app handle it
      // This allows the initial auth check to work properly
      if (isAuthUserRequest) {
        return Promise.reject(error);
      }

      // For all other 401 errors, redirect to login
      // This handles session expiry during normal app usage
      if (!isRedirecting) {
        isRedirecting = true;
        console.log('Session expired, redirecting to login...');
        window.location.href = '/?error=session_expired';
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export const authService = {
  // Get current user
  async getCurrentUser() {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/user`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        return null;
      }
      throw error;
    }
  },

  // Logout
  async logout() {
    try {
      await axios.post(`${API_BASE_URL}/auth/logout`);
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    }
  },

  // Redirect to EVE SSO login
  login() {
    window.location.href = `${API_BASE_URL}/auth/login`;
  }
};
